import * as React from 'react';
import classes from './signInDialog.module.scss';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import {IconButton, Toolbar} from "@mui/material";
import clsx from "clsx";
import SignInOrRegister from "./SignInOrRegister";

interface SignInDialogProps {
  open: boolean
  handleClose: () => void
  onSuccess: () => void
}

export function SignInDialog({open, handleClose, onSuccess, ...props}: SignInDialogProps) {
  return <>
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="product-item-dialog-title"
      className={classes.dialog}
      PaperProps={{
        className: classes.paper
      }}
    >

      <Toolbar className={clsx(classes.paperToolbar)}>
        <div className={classes.grow}></div>
        <IconButton
          component="div"
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          size="large">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Toolbar>

      <DialogContent className={classes.dialogContent}>
        <SignInOrRegister screen="signIn" onSuccess={onSuccess} />
      </DialogContent>

    </Dialog>
  </>;

}
